/**
 * Liste des pays avec leurs codes téléphoniques
 * Format ISO 3166-1 alpha-2 pour les codes pays
 */

export const countries = [
  { code: 'SN', name: 'Sénégal', phoneCode: '+221', flag: '🇸🇳' },
  { code: 'FR', name: 'France', phoneCode: '+33', flag: '🇫🇷' },
  { code: 'US', name: 'États-Unis', phoneCode: '+1', flag: '🇺🇸' },
  { code: 'GB', name: 'Royaume-Uni', phoneCode: '+44', flag: '🇬🇧' },
  { code: 'CA', name: 'Canada', phoneCode: '+1', flag: '🇨🇦' },
  { code: 'BE', name: 'Belgique', phoneCode: '+32', flag: '🇧🇪' },
  { code: 'CH', name: 'Suisse', phoneCode: '+41', flag: '🇨🇭' },
  { code: 'DE', name: 'Allemagne', phoneCode: '+49', flag: '🇩🇪' },
  { code: 'IT', name: 'Italie', phoneCode: '+39', flag: '🇮🇹' },
  { code: 'ES', name: 'Espagne', phoneCode: '+34', flag: '🇪🇸' },
  { code: 'PT', name: 'Portugal', phoneCode: '+351', flag: '🇵🇹' },
  { code: 'NL', name: 'Pays-Bas', phoneCode: '+31', flag: '🇳🇱' },
  { code: 'MA', name: 'Maroc', phoneCode: '+212', flag: '🇲🇦' },
  { code: 'DZ', name: 'Algérie', phoneCode: '+213', flag: '🇩🇿' },
  { code: 'TN', name: 'Tunisie', phoneCode: '+216', flag: '🇹🇳' },
  { code: 'CI', name: "Côte d'Ivoire", phoneCode: '+225', flag: '🇨🇮' },
  { code: 'ML', name: 'Mali', phoneCode: '+223', flag: '🇲🇱' },
  { code: 'BF', name: 'Burkina Faso', phoneCode: '+226', flag: '🇧🇫' },
  { code: 'NE', name: 'Niger', phoneCode: '+227', flag: '🇳🇪' },
  { code: 'MR', name: 'Mauritanie', phoneCode: '+222', flag: '🇲🇷' },
  { code: 'GN', name: 'Guinée', phoneCode: '+224', flag: '🇬🇳' },
  { code: 'GW', name: 'Guinée-Bissau', phoneCode: '+245', flag: '🇬🇼' },
  { code: 'GM', name: 'Gambie', phoneCode: '+220', flag: '🇬🇲' },
  { code: 'BJ', name: 'Bénin', phoneCode: '+229', flag: '🇧🇯' },
  { code: 'TG', name: 'Togo', phoneCode: '+228', flag: '🇹🇬' },
  { code: 'GH', name: 'Ghana', phoneCode: '+233', flag: '🇬🇭' },
  { code: 'NG', name: 'Nigeria', phoneCode: '+234', flag: '🇳🇬' },
  { code: 'CM', name: 'Cameroun', phoneCode: '+237', flag: '🇨🇲' },
  { code: 'TD', name: 'Tchad', phoneCode: '+235', flag: '🇹🇩' },
  { code: 'CF', name: 'République centrafricaine', phoneCode: '+236', flag: '🇨🇫' },
  { code: 'CG', name: 'Congo', phoneCode: '+242', flag: '🇨🇬' },
  { code: 'CD', name: 'RD Congo', phoneCode: '+243', flag: '🇨🇩' },
  { code: 'GA', name: 'Gabon', phoneCode: '+241', flag: '🇬🇦' },
  { code: 'GQ', name: 'Guinée équatoriale', phoneCode: '+240', flag: '🇬🇶' },
  { code: 'ST', name: 'São Tomé-et-Príncipe', phoneCode: '+239', flag: '🇸🇹' },
  { code: 'AO', name: 'Angola', phoneCode: '+244', flag: '🇦🇴' },
  { code: 'ZM', name: 'Zambie', phoneCode: '+260', flag: '🇿🇲' },
  { code: 'ZW', name: 'Zimbabwe', phoneCode: '+263', flag: '🇿🇼' },
  { code: 'BW', name: 'Botswana', phoneCode: '+267', flag: '🇧🇼' },
  { code: 'NA', name: 'Namibie', phoneCode: '+264', flag: '🇳🇦' },
  { code: 'ZA', name: 'Afrique du Sud', phoneCode: '+27', flag: '🇿🇦' },
  { code: 'LS', name: 'Lesotho', phoneCode: '+266', flag: '🇱🇸' },
  { code: 'SZ', name: 'Eswatini', phoneCode: '+268', flag: '🇸🇿' },
  { code: 'MZ', name: 'Mozambique', phoneCode: '+258', flag: '🇲🇿' },
  { code: 'MG', name: 'Madagascar', phoneCode: '+261', flag: '🇲🇬' },
  { code: 'MU', name: 'Maurice', phoneCode: '+230', flag: '🇲🇺' },
  { code: 'SC', name: 'Seychelles', phoneCode: '+248', flag: '🇸🇨' },
  { code: 'KM', name: 'Comores', phoneCode: '+269', flag: '🇰🇲' },
  { code: 'DJ', name: 'Djibouti', phoneCode: '+253', flag: '🇩🇯' },
  { code: 'ER', name: 'Érythrée', phoneCode: '+291', flag: '🇪🇷' },
  { code: 'ET', name: 'Éthiopie', phoneCode: '+251', flag: '🇪🇹' },
  { code: 'SO', name: 'Somalie', phoneCode: '+252', flag: '🇸🇴' },
  { code: 'KE', name: 'Kenya', phoneCode: '+254', flag: '🇰🇪' },
  { code: 'UG', name: 'Ouganda', phoneCode: '+256', flag: '🇺🇬' },
  { code: 'RW', name: 'Rwanda', phoneCode: '+250', flag: '🇷🇼' },
  { code: 'BI', name: 'Burundi', phoneCode: '+257', flag: '🇧🇮' },
  { code: 'TZ', name: 'Tanzanie', phoneCode: '+255', flag: '🇹🇿' },
  { code: 'MW', name: 'Malawi', phoneCode: '+265', flag: '🇲🇼' },
  { code: 'EG', name: 'Égypte', phoneCode: '+20', flag: '🇪🇬' },
  { code: 'SD', name: 'Soudan', phoneCode: '+249', flag: '🇸🇩' },
  { code: 'SS', name: 'Soudan du Sud', phoneCode: '+211', flag: '🇸🇸' },
  { code: 'LY', name: 'Libye', phoneCode: '+218', flag: '🇱🇾' },
  { code: 'BR', name: 'Brésil', phoneCode: '+55', flag: '🇧🇷' },
  { code: 'MX', name: 'Mexique', phoneCode: '+52', flag: '🇲🇽' },
  { code: 'AR', name: 'Argentine', phoneCode: '+54', flag: '🇦🇷' },
  { code: 'CL', name: 'Chili', phoneCode: '+56', flag: '🇨🇱' },
  { code: 'CO', name: 'Colombie', phoneCode: '+57', flag: '🇨🇴' },
  { code: 'PE', name: 'Pérou', phoneCode: '+51', flag: '🇵🇪' },
  { code: 'VE', name: 'Venezuela', phoneCode: '+58', flag: '🇻🇪' },
  { code: 'EC', name: 'Équateur', phoneCode: '+593', flag: '🇪🇨' },
  { code: 'BO', name: 'Bolivie', phoneCode: '+591', flag: '🇧🇴' },
  { code: 'PY', name: 'Paraguay', phoneCode: '+595', flag: '🇵🇾' },
  { code: 'UY', name: 'Uruguay', phoneCode: '+598', flag: '🇺🇾' },
  { code: 'CN', name: 'Chine', phoneCode: '+86', flag: '🇨🇳' },
  { code: 'JP', name: 'Japon', phoneCode: '+81', flag: '🇯🇵' },
  { code: 'KR', name: 'Corée du Sud', phoneCode: '+82', flag: '🇰🇷' },
  { code: 'IN', name: 'Inde', phoneCode: '+91', flag: '🇮🇳' },
  { code: 'PK', name: 'Pakistan', phoneCode: '+92', flag: '🇵🇰' },
  { code: 'BD', name: 'Bangladesh', phoneCode: '+880', flag: '🇧🇩' },
  { code: 'ID', name: 'Indonésie', phoneCode: '+62', flag: '🇮🇩' },
  { code: 'PH', name: 'Philippines', phoneCode: '+63', flag: '🇵🇭' },
  { code: 'TH', name: 'Thaïlande', phoneCode: '+66', flag: '🇹🇭' },
  { code: 'VN', name: 'Vietnam', phoneCode: '+84', flag: '🇻🇳' },
  { code: 'MY', name: 'Malaisie', phoneCode: '+60', flag: '🇲🇾' },
  { code: 'SG', name: 'Singapour', phoneCode: '+65', flag: '🇸🇬' },
  { code: 'AU', name: 'Australie', phoneCode: '+61', flag: '🇦🇺' },
  { code: 'NZ', name: 'Nouvelle-Zélande', phoneCode: '+64', flag: '🇳🇿' },
  { code: 'RU', name: 'Russie', phoneCode: '+7', flag: '🇷🇺' },
  { code: 'TR', name: 'Turquie', phoneCode: '+90', flag: '🇹🇷' },
  { code: 'SA', name: 'Arabie saoudite', phoneCode: '+966', flag: '🇸🇦' },
  { code: 'AE', name: 'Émirats arabes unis', phoneCode: '+971', flag: '🇦🇪' },
  { code: 'IL', name: 'Israël', phoneCode: '+972', flag: '🇮🇱' },
  { code: 'JO', name: 'Jordanie', phoneCode: '+962', flag: '🇯🇴' },
  { code: 'LB', name: 'Liban', phoneCode: '+961', flag: '🇱🇧' },
  { code: 'IQ', name: 'Irak', phoneCode: '+964', flag: '🇮🇶' },
  { code: 'IR', name: 'Iran', phoneCode: '+98', flag: '🇮🇷' },
  { code: 'AF', name: 'Afghanistan', phoneCode: '+93', flag: '🇦🇫' },
  { code: 'GR', name: 'Grèce', phoneCode: '+30', flag: '🇬🇷' },
  { code: 'PL', name: 'Pologne', phoneCode: '+48', flag: '🇵🇱' },
  { code: 'CZ', name: 'République tchèque', phoneCode: '+420', flag: '🇨🇿' },
  { code: 'HU', name: 'Hongrie', phoneCode: '+36', flag: '🇭🇺' },
  { code: 'RO', name: 'Roumanie', phoneCode: '+40', flag: '🇷🇴' },
  { code: 'BG', name: 'Bulgarie', phoneCode: '+359', flag: '🇧🇬' },
  { code: 'HR', name: 'Croatie', phoneCode: '+385', flag: '🇭🇷' },
  { code: 'RS', name: 'Serbie', phoneCode: '+381', flag: '🇷🇸' },
  { code: 'BA', name: 'Bosnie-Herzégovine', phoneCode: '+387', flag: '🇧🇦' },
  { code: 'SK', name: 'Slovaquie', phoneCode: '+421', flag: '🇸🇰' },
  { code: 'SI', name: 'Slovénie', phoneCode: '+386', flag: '🇸🇮' },
  { code: 'EE', name: 'Estonie', phoneCode: '+372', flag: '🇪🇪' },
  { code: 'LV', name: 'Lettonie', phoneCode: '+371', flag: '🇱🇻' },
  { code: 'LT', name: 'Lituanie', phoneCode: '+370', flag: '🇱🇹' },
  { code: 'FI', name: 'Finlande', phoneCode: '+358', flag: '🇫🇮' },
  { code: 'SE', name: 'Suède', phoneCode: '+46', flag: '🇸🇪' },
  { code: 'NO', name: 'Norvège', phoneCode: '+47', flag: '🇳🇴' },
  { code: 'DK', name: 'Danemark', phoneCode: '+45', flag: '🇩🇰' },
  { code: 'IS', name: 'Islande', phoneCode: '+354', flag: '🇮🇸' },
  { code: 'IE', name: 'Irlande', phoneCode: '+353', flag: '🇮🇪' },
  { code: 'LU', name: 'Luxembourg', phoneCode: '+352', flag: '🇱🇺' },
  { code: 'AT', name: 'Autriche', phoneCode: '+43', flag: '🇦🇹' },
  { code: 'MT', name: 'Malte', phoneCode: '+356', flag: '🇲🇹' },
  { code: 'CY', name: 'Chypre', phoneCode: '+357', flag: '🇨🇾' },
];

// Pays par défaut (Sénégal)
export const defaultCountry = countries.find(c => c.code === 'SN') || countries[0];

// Fonction pour trouver un pays par son code
export function getCountryByCode(code) {
  return countries.find(c => c.code === code) || defaultCountry;
}

// Fonction pour trouver un pays par son code téléphonique
// countryCodeHint : disambiguation +1 (US vs CA) depuis le sélecteur de pays
export function getCountryByPhoneCode(phoneCode, countryCodeHint) {
  if (countryCodeHint) {
    const byIso = countries.find((c) => c.code === countryCodeHint);
    if (byIso && byIso.phoneCode === phoneCode) {
      return byIso;
    }
  }
  return countries.find((c) => c.phoneCode === phoneCode) || defaultCountry;
}
